/**
 * Indicates that `fetchMore` was called on this query and that the query created is currently in
 * flight. Used to prevent entire component from re-rendering
 */
export const FETCH_MORE_NETWORK_STATUS = 3;
